/* Springwaves scratch card popup */
(function () {
  'use strict';
  var root = document.querySelector('[data-scratch]');
  if (!root) return;

  var KEY = 'sw_scratch';
  var designMode = root.hasAttribute('data-design-mode');
  var days = parseInt(root.getAttribute('data-days'), 10) || 7;
  var delay = (parseInt(root.getAttribute('data-delay'), 10) || 0) * 1000;
  var teaser = document.querySelector('[data-scratch-teaser]');
  var kKey = root.getAttribute('data-klaviyo-key');
  var kList = root.getAttribute('data-klaviyo-list'); // texts (SMS) list
  var kEmailList = root.getAttribute('data-klaviyo-email-list') || kList;
  var smsStep = root.getAttribute('data-sms-step') === 'true';
  var canvas = root.querySelector('[data-scratch-canvas]');
  var area = root.querySelector('[data-scratch-area]');
  var form = root.querySelector('[data-scratch-form]');
  var errorEl = root.querySelector('[data-scratch-error]');
  var shown = false;
  var revealed = false;

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  var state = get();

  function step(n) {
    root.querySelectorAll('[data-step]').forEach(function (s) {
      var on = s.getAttribute('data-step') === String(n);
      s.hidden = !on;
      s.classList.toggle('is-active', on);
    });
    state.step = n;
    if (!designMode) set(state);
    var f = root.querySelector('[data-step="' + n + '"] input, [data-step="' + n + '"] .choice');
    if (f && n > 1) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }

  function recentlyClosed() { return state.closedAt && (Date.now() - state.closedAt) < days * 86400000; }

  // Automatic triggers (timer, scroll depth, exit intent) fire at most once per page view.
  var armed = false, timer, onScroll, onExit;
  function disarm() {
    armed = false;
    clearTimeout(timer);
    if (onScroll) window.removeEventListener('scroll', onScroll);
    if (onExit) document.removeEventListener('mouseout', onExit);
  }
  function autoOpen() {
    if (!armed) return;
    disarm();
    state = get(); // pick up a gift claimed (or a close) in another tab
    if (state.done || recentlyClosed()) return;
    open();
  }

  function open() {
    if (shown) return;
    disarm();
    if (!designMode) state = get();
    if (state.done && !designMode) { if (teaser) teaser.hidden = true; return; }
    shown = true;
    root.hidden = false;
    if (teaser) teaser.hidden = true;
    document.body.classList.add('no-scroll');
    // resume where they left off: scratch (1), choose (2) or claim (3)
    var s = state.step && state.step < 4 ? state.step : 1;
    if (s === 3 && !state.gift) s = 2;
    showGift();
    step(s);
    if (s === 1) requestAnimationFrame(paint);
  }
  function close() {
    root.hidden = true;
    shown = false;
    document.body.classList.remove('no-scroll');
    disarm();
    if (!designMode) {
      if (!state.done) state.closedAt = Date.now();
      set(state);
    }
    if (teaser) teaser.hidden = !!state.done || root.getAttribute('data-teaser') !== 'true';
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-scratch-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && shown) close(); });
  if (teaser) teaser.addEventListener('click', function () { open(); });

  /* ---------- when to show ---------- */
  if (designMode) {
    // In the theme editor: don't interrupt editing, show the tab so it can be previewed with one click.
    if (teaser) teaser.hidden = false; else setTimeout(open, 300);
  } else if (state.done) {
    // already claimed a gift: never show again
  } else if (recentlyClosed()) {
    if (teaser && root.getAttribute('data-teaser') === 'true') teaser.hidden = false;
  } else {
    armed = true;
    timer = setTimeout(autoOpen, delay);
    onScroll = function () {
      var depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (depth > 0.55 && delay > 4000) autoOpen();
    };
    onExit = function (e) { if (!e.relatedTarget && e.clientY < 10) autoOpen(); };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mouseout', onExit);
  }

  /* ---------- scratch canvas ---------- */
  var ctx, w, h, dpr, moves = 0, drawing = false, last = null;
  function paint() {
    if (!canvas || revealed) return;
    dpr = window.devicePixelRatio || 1;
    w = area.clientWidth; h = area.clientHeight;
    canvas.width = w * dpr; canvas.height = h * dpr;
    ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    // brushed sterling-silver foil
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#b9bfc5'); g.addColorStop(0.28, '#eef1f3'); g.addColorStop(0.5, '#c3c9ce');
    g.addColorStop(0.72, '#f6f8f9'); g.addColorStop(1, '#aeb5bb');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    ctx.globalAlpha = 0.18;
    for (var i = 0; i < h; i += 2) { ctx.fillStyle = i % 4 ? '#ffffff' : '#9aa1a8'; ctx.fillRect(0, i, w, 1); }
    ctx.globalAlpha = 1;
    // sparkles
    for (var s = 0; s < 26; s++) {
      var x = Math.random() * w, y = Math.random() * h, r = Math.random() * 1.6 + 0.4;
      ctx.fillStyle = 'rgba(255,255,255,' + (0.5 + Math.random() * 0.5) + ')';
      ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
    }
    // label
    ctx.fillStyle = 'rgba(70,78,86,.85)';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '600 13px Jost, Arial, sans-serif';
    if ('letterSpacing' in ctx) ctx.letterSpacing = '3px';
    ctx.fillText('SCRATCH HERE', w / 2, h / 2 - 8);
    ctx.font = 'italic 500 15px "Cormorant Garamond", Georgia, serif';
    if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
    ctx.fillText('a little gift is waiting', w / 2, h / 2 + 14);
  }
  function pos(e) {
    var r = canvas.getBoundingClientRect();
    var p = e.touches ? e.touches[0] : e;
    return { x: p.clientX - r.left, y: p.clientY - r.top };
  }
  function scratchAt(p) {
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 38;
    ctx.beginPath();
    if (last) { ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke(); }
    ctx.arc(p.x, p.y, 19, 0, Math.PI * 2); ctx.fill();
    last = p;
    if (++moves % 6 === 0) check();
  }
  function check() {
    // reveal after just a little scratching (~16% of the foil)
    var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0, total = 0;
    for (var i = 3; i < data.length; i += 4 * 24) { total++; if (data[i] < 40) clear++; }
    if (clear / total > 0.16) reveal();
  }
  function reveal() {
    if (revealed) return;
    revealed = true;
    canvas.classList.add('is-cleared');
    confetti();
    setTimeout(function () { step(2); }, 1100);
  }
  function confetti() {
    var colors = ['#2c6a7b', '#c9a35a', '#e08aa3', '#9a6fd1', '#5fc7c4', '#f5be3a'];
    for (var i = 0; i < 26; i++) {
      var c = document.createElement('span');
      c.className = 'confetti';
      c.style.background = colors[i % colors.length];
      c.style.setProperty('--x', (Math.random() * 260 - 130) + 'px');
      c.style.setProperty('--y', (Math.random() * -150 - 20) + 'px');
      c.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg');
      area.appendChild(c);
      setTimeout(function (el) { el.remove(); }, 1200, c);
    }
  }
  if (canvas) {
    var start = function (e) { drawing = true; last = null; scratchAt(pos(e)); e.preventDefault(); };
    var move = function (e) { if (!drawing) return; scratchAt(pos(e)); e.preventDefault(); };
    var end = function () { drawing = false; last = null; if (ctx && !revealed) check(); };
    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', move);
    window.addEventListener('mouseup', end);
    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove', move, { passive: false });
    canvas.addEventListener('touchend', end);
    canvas.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); reveal(); } });
    // only repaint when the width really changes (mobile address bars fire resize while scrolling)
    window.addEventListener('resize', function () { if (shown && !revealed && area.clientWidth !== w) paint(); });
  }

  /* ---------- choose gift (step 2) ---------- */
  function showGift() {
    if (!state.gift) return;
    var g = root.querySelector('[data-scratch-gift]');
    if (g) g.textContent = state.gift.label;
    var tags = root.querySelector('[data-scratch-tags]');
    if (tags) tags.value = 'newsletter,scratch-card,gift-' + state.gift.code.toLowerCase();
  }
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-choice]');
    if (c) {
      state.gift = { code: c.getAttribute('data-code'), label: c.getAttribute('data-label') };
      showGift();
      step(3);
      return;
    }
    if (e.target.closest('[data-scratch-back]')) step(2);
    if (e.target.closest('[data-scratch-skip]')) step(5);
  });

  /* ---------- Klaviyo (client API, public key only) ---------- */
  function klaviyo(path, body) {
    if (!kKey) return Promise.resolve();
    return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(kKey), {
      method: 'POST',
      headers: { 'content-type': 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }
  function subscribe(attrs, listId) {
    if (!listId) return Promise.resolve();
    return klaviyo('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'Springwaves scratch card', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: listId } } } } });
  }
  // never leave someone waiting on a slow network: carry on after 6s
  function settle(jobs) {
    return Promise.race([Promise.all(jobs), new Promise(function (r) { setTimeout(r, 6000); })]);
  }

  /* ---------- claim with email (step 3) → apply discount automatically ---------- */
  var claimedEmail = '';
  function showError(el, msg) { if (el) { el.textContent = msg; el.hidden = !msg; } }
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      showError(errorEl, '');
      if (!state.gift) return step(2);
      var email = form.querySelector('[name="contact[email]"]').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError(errorEl, 'Please enter a valid email address.');
      var btn = form.querySelector('[data-scratch-submit]');
      btn.disabled = true; btn.textContent = 'Claiming…';
      var gift = state.gift;

      var jobs = [];
      // 1) Shopify customer (email marketing) → Shopify welcome emails with the same 10% / £5 gift.
      //    Klaviyo's profile sync creates the customer too; this direct post is a best-effort extra
      //    (Shopify may answer it with a bot check, which fetch never shows the shopper).
      var fd = new FormData(form);
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      jobs.push(fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {}));
      // 2) Klaviyo: email consent, plus the gift they chose so texts can quote their code
      jobs.push(subscribe({ email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, kEmailList));
      jobs.push(klaviyo('profiles', { data: { type: 'profile', attributes: { email: email, properties: { scratch_gift: gift.label, scratch_code: gift.code } } } }));
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      // 3) apply the discount to this browser's checkout
      jobs.push(fetch('/discount/' + encodeURIComponent(gift.code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {}));

      settle(jobs).then(function () {
        claimedEmail = email;
        try { localStorage.setItem('sw_gift', JSON.stringify({ code: gift.code, label: gift.label, at: Date.now() })); } catch (err) {}
        state.done = true;
        if (!designMode) set(state);
        var out = root.querySelector('[data-scratch-applied]');
        if (out) out.textContent = gift.label;
        if (window.swCart) window.swCart.giftBanner();
        btn.disabled = false; btn.textContent = 'Claim my gift';
        step(smsStep && kKey && kList ? 4 : 5);
      });
    });
  }

  /* ---------- optional: get the code by text (step 4) ---------- */
  function normPhone(v) {
    var p = (v || '').replace(/[^\d+]/g, '');
    if (p.indexOf('00') === 0) p = '+' + p.slice(2);
    if (p.charAt(0) === '0') p = '+44' + p.slice(1);
    if (p.charAt(0) !== '+' && p.length >= 10) p = '+' + p;
    return p;
  }
  var smsForm = root.querySelector('[data-scratch-sms]');
  if (smsForm) {
    var smsError = root.querySelector('[data-scratch-sms-error]');
    smsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      showError(smsError, '');
      var phone = normPhone(smsForm.querySelector('[name="scratch_phone"]').value);
      if (!/^\+\d{10,15}$/.test(phone)) return showError(smsError, 'Please enter a valid mobile number.');
      var btn = smsForm.querySelector('[data-scratch-sms-submit]');
      btn.disabled = true; btn.textContent = 'Sending…';
      var attrs = { phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (claimedEmail) attrs.email = claimedEmail;
      settle([subscribe(attrs, kList)]).then(function () {
        btn.disabled = false; btn.textContent = 'Text me my code';
        step(5);
      });
    });
  }
})();

